import ls from 'local-storage';

/**
 * Get the user's preferred CSV separator from local storage
 * @returns {string} The CSV separator (',' or ';')
 */
export const getUserCsvSeparator = () => {
    const st = ls.get('nw_config_userguiconfig');
    if (st && st.csv && st.csv.separator) {
        return st.csv.separator;
    }
    return ';'; // Default to semicolon
};

/**
 * Get the CSV separator from user configuration object
 * @param {Object} userGuiConfig - The user GUI configuration object
 * @returns {string} The CSV separator (',' or ';')
 */
export const getCsvSeparator = (userGuiConfig) => {
    if (userGuiConfig && userGuiConfig.csv && userGuiConfig.csv.separator) {
        return userGuiConfig.csv.separator;
    }
    return ';'; // Default to semicolon
};
